<template>
  <TableGradient
    icon-name="id-badge"
    title="VNS's"
    :fields="fields"
    :items="vns"
    :loading="isLoading"
    :fields-filter="filter"
    :paginator="pagination"
    @list="evt => $store.dispatch('vns/listAll', evt)"
    table-data>
    <template v-slot:cell(id)="linha">
      <router-link :id="'link-edit-' + linha.index" :to="{ name: 'vns.permissions.edit', params: { id: linha.item.id }}"
                   class="font-weight-bold">
        {{ $t('vns.permissoes.form.titulo_pagina') }}
      </router-link>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import TableData from "@/components/TableData";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "index",
  components: {TableData, TableGradient},
  computed: {
    ...mapGetters({
      vns: 'vns/all',
      store_isLoading: 'vns/isLoading',
      pagination: 'vns/pagination'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'name', label: this.$t('vns.permissoes.index.nome'), sortable: true},
        {key: 'id', label: this.$t('vns.permissoes.index.acoes')}
      ],
      filter: [
        {key: 'vns.name', label: this.$t('vns.permissoes.index.nome')},
      ],
    }
  },
  methods: {
    ...mapActions([
      'vns/listAll'
    ])
  },
  mounted() {
    this['vns/listAll']()
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
